import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LoginModal } from "@/components/LoginModal";
import { UpgradeModal } from "@/components/UpgradeModal";
import { NdaModal } from "@/components/NdaModal";
import Home from "@/pages/Home";
import Analysis from "@/pages/Analysis";
import Compare from "@/pages/Compare";
import Admin from "@/pages/Admin";
import RateLibrary from "@/pages/RateLibrary";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/analysis/:id" element={<Analysis />} />
            <Route path="/compare" element={<Compare />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/rates" element={<RateLibrary />} />
          </Routes>
          <LoginModal />
          <UpgradeModal />
          <NdaModal />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
